module.exports = __webpack_public_path__ + "static/img/1810_7.5a85f7f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/1810_7.jpg
// module id = pKM+
// module chunks = 1